import { render, staticRenderFns } from "./PresentDetail.vue?vue&type=template&id=563001c6&"
import script from "./PresentDetail.vue?vue&type=script&lang=js&"
export * from "./PresentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PresentDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports